import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import './Header.css';
import logo from '../../../assets/logo.png';
import { useNavigate } from 'react-router-dom';
import { ROUTES, SCHUTZBEDARFSANALYSE_MODULES } from '../../../config/constants';

const Header = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    const menuItems = [
        { label: 'Geldwäsche', route: null, implemented: false },
        {
            label: 'Informationssicherheit',
            route: ROUTES.SCHUTZBEDARFSANALYSE_PROZESSE,
            implemented: true,
            module: SCHUTZBEDARFSANALYSE_MODULES.INFORMATIONSSICHERHEIT
        },
        {
            label: 'Risikomanagement',
            route: ROUTES.SCHUTZBEDARFSANALYSE_RISIKEN,
            implemented: true,
            module: SCHUTZBEDARFSANALYSE_MODULES.RISIKOMANAGEMENT
        },
        { label: 'Business Cont. Mgt', route: null, implemented: false },
        { label: 'Datenschutz', route: null, implemented: false },
        { label: 'Meldewesen', route: null, implemented: false }
    ];

    const handleMenuClick = (item) => {
        if (item.implemented && item.route) {
            // ✅ Navigiere mit Modul-Parameter
            navigate(item.route, {
                state: {
                    module: item.module
                }
            });
        } else {
            alert(`${item.label} wird demnächst verfügbar sein`);
        }
    };

    return (
        <header className="app-header">
            <div className="logo-wrapper">
                <img src={logo} alt="Logo" className="logo-img" />
            </div>

            <div className="header-content">
                <nav className="header-nav">
                    {menuItems.map((item, index) => (
                        <button
                            key={index}
                            className={`nav-button ${!item.implemented ? 'not-implemented' : ''}`}
                            onClick={() => handleMenuClick(item)}
                        >
                            {item.label}
                            {!item.implemented && (
                                <span className="soon-badge">Bald</span>
                            )}
                        </button>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Header;